import { $ } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'
import { scalars } from '~/gql/utils/scalars'

const appConfigFields = {
  id: true,
  appName: true,
  logo: true,
  // Variante sombre du logo (#31) : servie avec le reste du branding parce que
  // le thème se choisit côté navigateur, donc les deux fichiers doivent être là.
  logoDark: true,
  favicon: true,
  primaryColor: true,
  primaryForeground: true,
  accentColor: true,
  accentForeground: true,
  footerText: true,
  defaultLocale: true,
  // Accroche d'acquisition sur l'écran de connexion (#216) : servie ici parce
  // que la décision se prend pré-auth, comme le branding.
  signupCtaVisible: true,
  // Fuseau de l'org (#194) : toute borne de parcours se relit dedans, pas dans
  // celui du navigateur. Servi ici parce que cette query est déjà chargée
  // globalement, avant login compris.
  timezone: true,
  // Achat de formule en libre-service (#165) : coupé, la facturation est masquée aux organisations.
  billingSelfService: true,
} as const

export const GQL_APP_CONFIG = typedGql('query', { scalars })({
  appConfig: appConfigFields,
})

export const GQL_UPDATE_APP_CONFIG = typedGql('mutation')({
  updateAppConfig: [
    {
      input: $('input', 'UpdateAppConfigInput!'),
    },
    appConfigFields,
  ],
})
